export default __webpack_public_path__ + "static/media/money-back@2x.d80dbd10.png";